var x = Object.defineProperty, d = (e, t) => x(e, "name", { value: t, configurable: !0 }), H = "https://api.topsort.com", b = { auctions: "v2/auctions", events: "v2/events" }, _ = "0.3.1", T = class {
  constructor(t, s, r, n = !1) {
    this.status = t, this.statusText = s, this.body = r, this.retry = n;
  }
};
d(T, "AppError");
var j = T, l = j, v = class {
  async handleResponse(t) {
    let s;
    if (t.status !== 204 && (s = await t.json()), !t.ok) {
      let r = t.status === 429 || t.status >= 500;
      throw new l(t.status, t.statusText, s, r);
    }
    return s;
  }
  async request(t, s) {
    try {
      let r = this.sanitizeUrl(t), n = await fetch(r, s);
      return this.handleResponse(n);
    } catch (r) {
      let n = r instanceof Error ? r.message : "Unknown error";
      throw new l(500, "Internal Server Error", n);
    }
  }
  setupTimeoutSignal(t) {
    if (t.timeout != null) {
      let s = new AbortController();
      return setTimeout(() => s.abort(), t.timeout), s.signal;
    }
  }
  async post(t, s, r) {
    let n = this.setupTimeoutSignal(r);
    return this.request(t, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json", "X-UA": r.userAgent ? `@topsort/sdk ${_} ${r.userAgent}` : `@topsort/sdk ${_}`, Authorization: `Bearer ${r.apiKey}` }, body: JSON.stringify(s), signal: n });
  }
  sanitizeUrl(t) {
    try {
      return new URL(t).href.replace(/\/+$/, "");
    } catch (s) {
      throw new l(400, "Invalid URL", { error: `Invalid URL: ${s}` });
    }
  }
};
d(v, "APIClient");
var B = v, k = new B();
function O(e) {
  var t;
  if (!((t = e == null ? void 0 : e.apiKey) != null && t.length))
    throw new l(401, "API Key is required.", {});
}
d(O, "validateConfig");
function m(e) {
  return async (...t) => {
    let s = t[t.length - 1];
    return O(s), e(...t);
  };
}
d(m, "withValidation");
async function A(e, t) {
  let s = `${t.host}/${b.auctions}`;
  return await k.post(s.toString(), e, t);
}
d(A, "handler");
var D = m(A);
async function P(e, t) {
  try {
    let s = `${t.host}/${b.events}`;
    return await k.post(s, e, t), { ok: !0, retry: !1 };
  } catch (s) {
    if (s instanceof l && s.retry)
      return { ok: !1, retry: !0 };
    throw s;
  }
}
d(P, "handler");
var K = m(P), M = class {
  constructor(t) {
    this.config = t, this.config.host = this.config.host ?? H;
  }
  async reportEvent(t) {
    return K(t, this.config);
  }
  async createAuction(t) {
    return D(t, this.config);
  }
};
d(M, "TopsortClient");
var X = M, z = X;
const J = "2.4.0";
class C {
  constructor() {
    this._data = [];
  }
  get() {
    return this._data;
  }
  set(t) {
    this._data = t;
  }
}
class S {
  constructor(t) {
    this._key = t, this._storage = window.localStorage;
  }
  get() {
    const t = this._storage.getItem(this._key);
    return t ? JSON.parse(t) : [];
  }
  set(t) {
    this._storage.setItem(this._key, JSON.stringify(t));
  }
}
class Y {
  constructor(t) {
    this._key = t, this._storage = window.sessionStorage, this._bid = void 0;
  }
  get() {
    try {
      return this._storage.getItem(this._key) ?? void 0;
    } catch {
      return this._bid;
    }
  }
  set(t) {
    this._bid = t;
    try {
      this._storage.setItem(this._key, t);
    } catch {
    }
  }
}
const G = "ts-t", Z = "ts-q", V = 250, W = 3, F = 25, Q = 250, I = 9, tt = 0;
function et(e, t) {
  return t > 0 ? e + (Math.random() + Math.pow(2, t)) * 1e3 : 0;
}
function st() {
  var t;
  const e = new S(G);
  try {
    const s = "3";
    if (e.set([{ x: s }]), ((t = e.get()[0]) == null ? void 0 : t.x) === s)
      return new S(Z);
  } catch {
  }
  return new C();
}
class rt {
  constructor(t) {
    this._store = st(), this._processing = /* @__PURE__ */ new Set(), this._scheduled = !1, this._processor = t;
  }
  append(t, s) {
    let r = this._store.get();
    r.push({
      e: t,
      r: 0,
      p: s != null && s.highPriority ? I : tt
    }), r = r.slice(-V), this._setEntries(r);
  }
  async _processNow(t) {
    if (!t.length)
      return;
    const s = [];
    for (let i = t.length - 1; i >= 0 && s.length < F; i--) {
      const a = t[i], u = a == null ? void 0 : a.e;
      u && !this._processing.has(u.id) && et(u.t, a.r) <= Date.now() && (s.push(u), this._processing.add(u.id));
    }
    if (!s.length) {
      this._scheduleProcessing();
      return;
    }
    let r = { done: /* @__PURE__ */ new Set(), retry: /* @__PURE__ */ new Set() };
    try {
      r = await this._processor(s);
    } catch {
      for (const a of s)
        r.done.add(a.id);
    }
    const n = [];
    for (const i of this._processing)
      s.find((a) => a.id === i) || n.push(i);
    this._processing = new Set(n);
    const o = this._store.get(), c = [];
    for (const i of o)
      r.done.has(i.e.id) || (r.retry.has(i.e.id) ? i.r < W && (i.r += 1, c.push(i)) : c.push(i));
    this._setEntries(c);
  }
  _setEntries(t) {
    this._store.set(t), t.length && (t.some((s) => s.p === I) || this._store instanceof C ? this._processNow(t) : this._scheduleProcessing());
  }
  _scheduleProcessing() {
    this._scheduled || (this._scheduled = !0, setTimeout(() => {
      this._scheduled = !1, this._processNow(this._store.get());
    }, Q));
  }
}
function nt(e, t) {
  if (e.size <= t)
    return e;
  const s = e.values();
  for (let r = 0; r < e.size - t; ++r)
    s.next();
  return new Set(s);
}
const ot = 2500, it = 0.5;
let f = /* @__PURE__ */ new Set();
const N = new Y("ts-b");
function R() {
  var e, t;
  return ((t = (e = window.URL).createObjectURL) == null ? void 0 : t.call(e, new Blob()).split("/").pop()) || Math.random() + "";
}
let h;
function y() {
  if (h)
    return h;
  const e = at();
  if (e)
    return h = e, e;
  const t = R();
  return U(t), t;
}
function U(e) {
  const t = window.TS.cookieName || "tsuid";
  h = e, document.cookie = t + "=" + e + ";max-age=31536000";
}
function ct() {
  return h = void 0, document.cookie = "tsuid=", y();
}
window.TS.setUserId = U;
window.TS.getUserId = y;
window.TS.resetUserId = ct;
function at() {
  var s;
  const e = window.TS.cookieName || "tsuid";
  return (s = new RegExp("(^|;)\\s*" + e + "\\s*=\\s*([^;]+)").exec(document.cookie)) == null ? void 0 : s.pop();
}
function dt(e) {
  const t = e.type, s = {
    path: e.page
  };
  let r;
  e.product && (r = {
    type: "product",
    id: e.product
  });
  let n;
  e.additionalProduct && (n = {
    type: "product",
    id: e.additionalProduct
  });
  const o = new Date(e.t).toISOString();
  switch (t) {
    case "Click":
      return {
        clicks: [
          {
            resolvedBidId: e.bid,
            entity: r,
            additionalAttribution: n,
            placement: s,
            occurredAt: o,
            opaqueUserId: e.uid,
            id: e.id
          }
        ]
      };
    case "Impression":
      return {
        impressions: [
          {
            resolvedBidId: e.bid,
            entity: r,
            additionalAttribution: n,
            placement: s,
            occurredAt: o,
            opaqueUserId: e.uid,
            id: e.id
          }
        ]
      };
    case "Purchase":
      return {
        purchases: [
          {
            occurredAt: o,
            opaqueUserId: e.uid,
            items: (e.items || []).map((c) => ({
              productId: c.product,
              quantity: c.quantity,
              unitPrice: c.price
            })),
            id: e.id
          }
        ]
      };
  }
}
async function ut(e) {
  const t = {
    done: /* @__PURE__ */ new Set(),
    retry: /* @__PURE__ */ new Set()
  }, s = [], r = {
    apiKey: window.TS.token,
    host: window.TS.url,
    userAgent: `ts.js/${J}`
  }, n = new z(r);
  for (const o of e)
    s.push(
      n.reportEvent(dt(o)).then((c) => {
        (c.retry ? t.retry : t.done).add(o.id);
      }).catch(() => {
        t.done.add(o.id);
      })
    );
  return await Promise.all(s), t;
}
const lt = new rt(ut);
function p(e, t) {
  const s = ht(e);
  if (f.has(s))
    return;
  f.add(s), f = nt(f, ot), lt.append(e);
  const r = new CustomEvent("topsort", { bubbles: !0, detail: e });
  t.dispatchEvent(r);
}
function ht(e) {
  const t = JSON.stringify(e.items || []);
  return [e.page, e.type, e.product ?? e.additionalProduct, e.bid, t].join(
    "-"
  );
}
function ft() {
  const e = window.location, t = e.hash;
  return t[1] === "/" ? t : `${e.pathname}${e.search}`;
}
function w(e, t) {
  let s = t.dataset.tsProduct, r = t.dataset.tsResolvedBid, n;
  r == "inherit" && s && (e == "Click" || e == "Impression") && (r = N.get(), n = s, s = void 0);
  const o = {
    type: e,
    product: s,
    additionalProduct: n,
    bid: r,
    t: Date.now(),
    page: ft(),
    id: R(),
    uid: y()
  };
  return e === "Purchase" && (o.items = JSON.parse(t.dataset.tsItems || "[]")), o;
}
function pt(e) {
  if (!(e.currentTarget instanceof HTMLElement))
    return;
  const t = e.currentTarget.closest(L);
  if (t && t instanceof HTMLElement) {
    const s = w("Click", t);
    p(s, t), s.bid && N.set(s.bid);
  }
}
const g = window.IntersectionObserver ? new IntersectionObserver(
  (e) => {
    for (const t of e)
      if (t.isIntersecting) {
        const s = t.target;
        s instanceof HTMLElement && (p(w("Impression", s), s), g && g.unobserve(s));
      }
  },
  {
    threshold: it
  }
) : void 0, L = "[data-ts-product],[data-ts-action],[data-ts-items],[data-ts-resolved-bid]";
function wt(e) {
  const t = e.querySelectorAll("[data-ts-clickable]");
  (t.length === 0 ? [e] : t).forEach((r) => r.addEventListener("click", pt));
}
function q(e) {
  gt(e) ? p(w("Purchase", e), e) : (g ? g.observe(e) : p(w("Impression", e), e), wt(e));
}
function $(e) {
  const t = e.querySelectorAll(L);
  for (let s = 0; s < t.length; s++) {
    const r = t[s];
    r instanceof HTMLElement && q(r);
  }
}
function gt(e) {
  return e.dataset.tsAction === "purchase";
}
function mt(e) {
  for (const t of e)
    if (t.type === "childList") {
      const s = /* @__PURE__ */ new Set();
      for (let r = 0; r < t.addedNodes.length; r++) {
        const n = t.addedNodes[r];
        if ((n == null ? void 0 : n.nodeType) === Node.ELEMENT_NODE) {
          const o = n.parentElement;
          o && !s.has(o) && s.add(o);
        }
        for (const o of s)
          $(o);
      }
    } else if (t.type === "attributes") {
      if (!(t.target instanceof HTMLElement))
        continue;
      q(t.target);
    }
}
function E() {
  var s, r;
  if ((s = window.TS) != null && s.loaded)
    return;
  if (window.TS.loaded = !0, !((r = window.TS) != null && r.token)) {
    console.error("Missing TS token");
    return;
  }
  $(document);
  const e = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
  new e(mt).observe(document, {
    attributes: !0,
    childList: !0,
    subtree: !0,
    attributeFilter: ["data-ts-product", "data-ts-action", "data-ts-items", "data-ts-resolved-bid"]
  });
}
/complete|interactive|loaded/.test(document.readyState) ? E() : window.addEventListener("DOMContentLoaded", E);
